// @TODO: combine with public web one
/**
 * Ryan O'Dowd
 * 2022-03-30
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import EmptyScreen from '@components/common/EmptyScreen';
import Faq from './Faq';
import FullScreenScrollView from '@components/common/FullScreenScrollView';
import Header from '@components/Header';
import ScreenWrapper from '@containers/ScreenWrapper';
import Searchbar from '@components/common/Searchbar';
import SectionList from '@components/common/SectionList';
import {
  View,
} from 'react-native';
import faqs from './faqs';
import getStyles from './styles';
import hooks from '@hooks';

const Help = () => {
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);
  const locationState = hooks.useLocationState();

  const [_searchOpen, setSearchOpen] = useState(false);
  const [_searchText, setSearchText] = useState(locationState.q || '');

  const oakUser = hooks.useTypedSelector((state) => state.oakUser);

  hooks.useBackButton(() => {
    if (_searchOpen) {
      setSearchOpen(false);
      return true;
    } else {
      navigation.goBack();
    }
    return true;
  });

  // from chatgpt
  const _extractTextFromJSX = (element) => { // @TODO: could maybe live in utilities, but i don't want to make a habit of using stuff like this
    if (typeof element === 'string') {
      return element;
    }

    if (React.isValidElement(element)) {
      const {children} = element.props as any;

      if (Array.isArray(children)) {
        return children.map(_extractTextFromJSX).join('');
      }

      return _extractTextFromJSX(children);
    }

    return '';
  };

  const searchItem = (
    <Header.Icon
      icon='magnify'
      onPress={() => {
        const newSearchOpenState = !_searchOpen;
        if (!newSearchOpenState) {
          setSearchText('');
        }
        setSearchOpen(newSearchOpenState);
      }}
    />
  );

  let filteredSections = faqs(styles, navigation, oakUser ? oakUser.isAnonymousUser : true, oakUser).sections.filter((section) => !section.ignoreInFaq);
  if (_searchText) {
    const tempSections = [];
    const searchTerms = _searchText.toLocaleLowerCase().split(' ');
    filteredSections.forEach((section) => { // @TODO: shouldn't this be a filter instead of a forEach?
      const filteredSection = {...section};
      filteredSection.data = filteredSection.data.filter((faq) => {
        return searchTerms.every((searchTerm) => {
          if (filteredSection.title.toLocaleLowerCase().includes(searchTerm)) {
            return true;
          }

          // @TODO: should these have the call to `.replace(/&#x27;/g, "'");`? (see tibbits)
          const questionText = _extractTextFromJSX(faq.question);
          const answerText = _extractTextFromJSX(faq.answer);
          if (questionText.toLocaleLowerCase().includes(searchTerm)) {
            return true;
          }

          if (answerText.toLocaleLowerCase().includes(searchTerm)) {
            return true;
          }

          return false;
        });
      });
      if (filteredSection.data.length) {
        tempSections.push(filteredSection);
      }
    });

    filteredSections = tempSections;
  }

  // @TODO: console.log(filteredSections);

  const backIcon = <Header.BackIcon />;

  return (
    <ScreenWrapper>
      {/* @TODO: add feedback-chat icon in top right next to search...maybe eventually, this is the only place to find chat? need to make sure badges work */}
      <Header
        leftItems={[backIcon]}
        rightItems={[searchItem]}
        title='Help Documentation'
      />
      <FullScreenScrollView>
        {_searchOpen &&
          <Searchbar
            onChangeText={(searchText) => setSearchText(searchText)}
            value={_searchText}
            placeholder='Question, answer, or topic'
            autoFocus={true}
          />
        }
        {!filteredSections.length &&
          <View style={styles.containerInner}>{/* @TODO: style doesn't exist */}
            <EmptyScreen.Text>
              {`No search results for ${_searchText}`}
            </EmptyScreen.Text>
          </View>
        }

        <SectionList
          contentContainerStyle={styles.list}
          sections={filteredSections}
          renderItem={({
            item, index, section,
          }) => <Faq faq={item} index={index} section={section} />}
        />
      </FullScreenScrollView>
    </ScreenWrapper>
  );
};

export default Help;
